/**
 * Theme preference. Persists in localStorage; falls back to
 * prefers-color-scheme. Applies `data-theme="dark"` on <html> so the
 * tokens in globals.css activate.
 */

export type Theme = "light" | "dark";

const KEY = "sm.theme";

export function loadTheme(): Theme {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem(KEY);
  if (stored === "light" || stored === "dark") return stored;
  const prefersDark =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
}

export function saveTheme(theme: Theme): void {
  window.localStorage.setItem(KEY, theme);
  applyTheme(theme);
}
